import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';
import React, { useState } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import NotificationCenter from './NotificationCenter';

export default function Notifications({
  color,
  notifications,
  additionalConfiguration,
  channelsState,
  onChannelsStateChange,
  onClose,
  onGoBack,
  onPerformAction,
  onMarkAllAsRead,
  onOpenUpdateProfile,
  onOpenVerificationDialog,
  person,
  totalUnreadNotifications,
  loading,
  hasNextPage,
  onLoadMore,
}) {
  const [open, setOpen] = useState(false);

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore,
  });

  return (
    <>
      <IconButton sx={{ color }} onClick={() => setOpen(true)}>
        <Badge badgeContent={totalUnreadNotifications} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationCenter
        open={open}
        onClose={() => {
          setOpen(false);
          onClose();
        }}
        onGoBack={onGoBack}
        notifications={notifications}
        additionalConfiguration={additionalConfiguration}
        channelsState={channelsState}
        onChannelsStateChange={onChannelsStateChange}
        onMarkAllAsRead={onMarkAllAsRead}
        person={person}
        onPerformAction={notification => {
          onPerformAction(notification);
          setOpen(false);
        }}
        onOpenUpdateProfile={onOpenUpdateProfile}
        onOpenVerificationDialog={onOpenVerificationDialog}
        forwardRef={sentryRef}
        hasNextPage={hasNextPage}
        loading={loading}
      />
    </>
  );
}
